import styles from './style.module.scss';
import { List, Divider, Row, Col, Spin } from 'antd';
import { Button, PageHeader } from 'components';
import { Link, useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import usePrestigeLevels from '../usePrestigeLevels';

const SinglePrestigeLevels = () => {
  const { t } = useTranslation();
  const { singleData, loading } = usePrestigeLevels(false);
  const [searchParams] = useSearchParams();

  const isSuccessUpdatePage = searchParams.get('success') === 'true';

  const dataKeys = [
    { key: 'title', text: t('Titolo') },
    { key: 'nego_tov_id', text: t('NEGO ID (TOV)') },
    { key: 'nego_sov_id', text: t('NEGO ID (SOV)') },
    { key: 'nego_rov_id', text: t('NEGO ID (ROV)') },
  ];

  const title = isSuccessUpdatePage
    ? t('PRESTIGE LEVEL WAS SUCCESSFULLY UPDATED.')
    : t('PRESTIGE LEVEL');

  return (
    <div>
      <PageHeader title={title} />
      <div className={styles.content}>
        <Spin spinning={loading}>
          <List
            header={<div>{t('PRESTIGE LEVEL')}</div>}
            dataSource={dataKeys}
            renderItem={(item) => (
              <List.Item>
                <b className={styles.itemName}>{item.text}</b>
                {singleData?.[item.key]}
              </List.Item>
            )}
          />
        </Spin>
        <Divider />
        <Row gutter={16}>
          {singleData?.can_update !== false && (
            <Col>
              <Button>
                <Link to={`/admin/prestige_levels/${singleData?.id}/edit`}>
                  {t('MODIFIICA')}
                </Link>
              </Button>
            </Col>
          )}
          <Col>
            <Button type={'secondary'}>
              <Link to={'/admin/prestige_levels'}>{t('TORNA INDIETRO')}</Link>
            </Button>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default SinglePrestigeLevels;
